import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();

  const filters = {
    DESIGN: "Desing",
    BRAND: "Brand",
    PHOTOS: "Photos",
  };

  const projectsData = [
    // {
    //   title: "Project Title 1",
    //   projectInfo:
    //     "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
    //   client: "Ruby Clinton",
    //   technologies: "iOS, HTML5, CSS3, PHP, Java",
    //   industry: "Art & Design",
    //   date: "July 16, 2019",
    //   url: {
    //     name: "www.example.com",
    //     link: "https://www.example.com",
    //   },
    //   socialLinks: {
    //     facebook: "http://www.facebook.com/",
    //     twitter: "http://www.twitter.com/",
    //     google: "http://www.google.com/",
    //     instagram: "http://www.instagram.com/",
    //     mail: "mailto:example@gmail.com",
    //   },
    //   thumbImage: "images/projects/project-1.jpg",
    //   sliderImages: [
    //     "images/projects/project-1.jpg",
    //     "images/projects/project-5.jpg",
    //   ],
    //   categories: [filters.BRAND],
    // },
    {
      title: "Full Stack Evangadi Forum (Q&A Platform)",
      projectInfo:
        "A Stack Overflow–style forum built with React, allowing users to ask questions, post answers, and interact with others. Features include full CRUD functionality for questions and answers, making it easy to edit or delete your own content. Designed with a responsive layout for smooth use across all devices.",

      technologies: "React, CSS3",
      date: "Sep 07, 2025",
      url: {
        name: "www.tsehayef.com",
        link: "https://tsehay21.github.io/EvangadiForumFrontEnd/",
      },
      socialLinks: {
        facebook: "https://github.com/Tsehay21/EvangadiForumFrontEnd",
        // twitter: "http://www.twitter.com/",
        // google: "http://www.google.com/",
        // instagram: "http://www.instagram.com/",
        // mail: "mailto:example@gmail.com",
      },
      thumbImage: "images/projects/evangadi-forum.jpg",
      sliderImages: [
        "images/projects/evangadi-forum.jpg",
        "images/projects/evangadi-forum.jpg",
      ],
      categories: [filters.DESIGN],
    },
    // {
    //   title: "Project Title 3",
    //   projectInfo:
    //     "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
    //   client: "Ruby Clinton",
    //   technologies: "iOS, HTML5, CSS3, PHP, Java",
    //   industry: "Art & Design",
    //   date: "July 16, 2019",
    //   url: {
    //     name: "www.example.com",
    //     link: "https://www.example.com",
    //   },
    //   socialLinks: {
    //     facebook: "http://www.facebook.com/",
    //     twitter: "http://www.twitter.com/",
    //     google: "http://www.google.com/",
    //     instagram: "http://www.instagram.com/",
    //     mail: "mailto:example@gmail.com",
    //   },
    //   thumbImage:
    //     "images/projects/WhatsApp Image 2025-04-09 at 12.40.45_521ab11d.jpg",
    //   sliderImages: [
    //     "images/projects/project-3.jpg",
    //     "images/projects/project-5.jpg",
    //   ],
    //   categories: [filters.PHOTOS],
    // },
    {
      title: "Netflix Clone",
      projectInfo:
        "A Netflix clone built with React and TMDB API, featuring real-time data fetching and a responsive design for an optimal viewing experience across various devices.",
      // client: "Ruby Clinton",
      technologies: "React, CSS3",

      date: "July 16, 2025",
      url: {
        name: "www.tsehayef.com",
        link: "https://tsehay21.github.io/Netflix-clone-new/",
      },
      socialLinks: {
        facebook: "https://github.com/Tsehay21/Netflix-clone-new",
        // twitter: "http://www.twitter.com/",
        // google: "http://www.google.com/",
        // instagram: "http://www.instagram.com/",
        // mail: "mailto:example@gmail.com",
      },
      thumbImage: "images/projects/Netflix.jpg",
      sliderImages: [
        "images/projects/netflix-clone.jpg",
        "images/projects/Netflix.jpg",
      ],
      categories: [filters.BRAND, filters.PHOTOS],
    },
    // {
    //   title: "YouTube Clone",
    //   projectInfo:
    //     "A YouTube clone built with React.js, showcasing a responsive layout, embedded video playback, and a clean, modern interface inspired by the real platform.",
    //   // client: "Ruby Clinton",
    //   technologies: "React, CSS3,",
    //   // industry: "Art & Design",
    //   date: "July 16, 2019",
    //   url: {
    //     name: "www.example.com",
    //     link: "https://www.example.com",
    //   },
    //   socialLinks: {
    //     facebook: "http://www.facebook.com/",
    //     twitter: "http://www.twitter.com/",
    //     google: "http://www.google.com/",
    //     instagram: "http://www.instagram.com/",
    //     mail: "mailto:example@gmail.com",
    //   },
    //   thumbImage: "images/projects/youtube.png",
    //   sliderImages: [
    //     "images/projects/youtube.png",
    //     "images/projects/youtube.png",
    //   ],
    //   categories: [filters.DESIGN],
    // },
    {
      title: "Apple React Clone with YouTube API Integration",
      projectInfo:
        "A React-based clone of Apple’s 2021 homepage featuring smooth scrolling, responsive layout, and YouTube API integration to dynamically display promotional video content. Designed with precision to reflect Apple’s clean interface and performance standards.",
      // client: "Ruby Clinton",
      technologies: "React, CSS3, Bootstrap, YouTube API,Node.js,Express.js",
      // industry: "Art & Design",
      date: "Apri 20, 2025",
      url: {
        name: "www.tsehayef.com",
        link: "https://www.example.com",
      },
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "images/projects/Apple.jpg",
      sliderImages: [
        "images/projects/Apple22.jpg",
        "images/projects/Apple.jpg",
      ],
      categories: [filters.BRAND],
    },
    {
      title: "Amazon Full Stack Clone",
      projectInfo:
        "A full stack clone of Amazon featuring user authentication with Firebase, secure payment processing with Stripe, and custom backend logic for cart management and order handling. Designed with a focus on performance, scalability, and seamless user experience.",
      // client: "Ruby Clinton",
      technologies: "React, CSS3, Firebase, Stripe,Node.js,Express.js",
      // industry: "Art & Design",
      date: "Nov 10, 2025",
      url: {
        name: "www.tsehayef.com",
        link: "https://tsehay21.github.io/Amazon-Clone-Front/",
      },
      socialLinks: {
        facebook: "https://github.com/Tsehay21/Amazon-Clone-Front",
        // twitter: "http://www.twitter.com/",
        // google: "http://www.google.com/",
        // instagram: "http://www.instagram.com/",
        // mail: "mailto:example@gmail.com",
      },
      thumbImage: "images/projects/Amazon.jpg",
      sliderImages: [
        "images/projects/Amazon.jpg",
        "images/projects/Amazon.jpg",
      ],
      categories: [filters.DESIGN, filters.PHOTOS],
    },
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  return (
    <>
      <section
        id="portfolio"
        className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative d-flex text-center mb-5">
            <h2
              className={
                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
              }
            >
              Portfolio
            </h2>
            <p
              className={
                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                (darkTheme ? "text-white" : "text-dark")
              }
            >
              {" "}
              My Work
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
              (darkTheme ? "nav-light" : "")
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " +
                    (filterKey === filters[oneKey] ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(filters[oneKey])}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      project.categories.join(" ")
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div className="portfolio-overlay">
                          <a
                            className="popup-ajax stretched-link"
                            href=""
                            onClick={() => {
                              setSelectedProjectDetails(projectsData[index]);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          />
                          <div className="portfolio-overlay-details">
                            <h5 className="text-white fw-400">
                              {project.title}
                            </h5>
                            <span className="text-light">Category</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
